export const footerNavAccordion = () => {
    
    const toggleIcons = document.querySelectorAll('.toggle-nav-list');

    toggleIcons.forEach(icon => {
        icon.addEventListener('click', function() {
            const ulElement = this.closest('div').nextElementSibling;

            this.classList.toggle('open');

            if (ulElement.classList.contains('open')) {
                ulElement.classList.remove('open');
            } else {
                ulElement.classList.add('open');
            }
        });
    });
};